import(/* webpackMode: "eager" */ "/workspace/src/app/terms-of-service/page.tsx");
